import { create } from 'zustand'
import { JwtPayload } from '../utils/token'

interface AuthState {
    idToken: string | null
    payload: JwtPayload | null
}

export const useAuthStore = create<AuthState>(() => ({
    idToken: null,
    payload: null,
}))

/** The signed-in account's stable identity (the JWT's `sub` claim) — unlike `idToken` itself,
 * this stays the same across a credential renewal and only changes on an actual account switch
 * (sign-out, then a different account signs in). Use this, not the raw token, wherever a stale
 * cross-session response needs to be told apart from a same-account token refresh. */
export const currentAccountId = (): string | null => useAuthStore.getState().payload?.sub ?? null
